import { render, staticRenderFns } from "./ContractSalariesInput.vue?vue&type=template&id=4317bb00&"
import script from "./ContractSalariesInput.vue?vue&type=script&lang=js&"
export * from "./ContractSalariesInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports